<template>
  <div class="container">
    <div class="content-teasers text-icon-teaser row row-narrow text-center">
      <div
        v-for="(item, index) in teaserElements"
        :key="item.href + '_' + index"
        :class="`content-teaser col-md-3 ${teaserVariant}`"
      >
        <div>
          <div class="body">
            <h4 class="header d-flex justify-content-center align-items-start">
              {{ $t(item.head) }}
            </h4>
            <div class="main d-flex justify-content-center align-items-center">
              <div v-dompurify-html="$t(item.html)" />
            </div>
            <div class="footer d-flex justify-content-center align-items-end mt-3">
              <i :class="item.iconClass ? item.iconClass : 'icon'">
                <component :is="item.icon" />
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IconHomeLg from 'ICON:IconHomeLg';
import IconThumbsUp from 'ICON:IconThumbsUp';
import IconMedal from 'ICON:IconMedal';
import IconShieldAlt from 'ICON:IconShieldAlt';
import IconAgencyContact from 'ICON:IconAgencyContact';
import IconAgencyAnswer from 'ICON:IconAgencyAnswer';
import IconAgencyContract from 'ICON:IconAgencyContract';
import IconAgencyActivation from 'ICON:IconAgencyActivation';

export default {
  name: 'ContentTextIconTeaser',
  components: {
    IconHomeLg,
    IconThumbsUp,
    IconMedal,
    IconShieldAlt,
    IconAgencyContact,
    IconAgencyAnswer,
    IconAgencyContract,
    IconAgencyActivation,
  },
  mixins: [AnchorRouterPush],
  props: {
    teaserElements: {
      required: false,
      type: Array,
      default: () => [],
    },
    teaserVariant: {
      required: false,
      type: String,
      default: 'light',
    },
  },
};
</script>

<style lang="scss" scoped>
  .content-teasers.text-icon-teaser {
    .header,
    .main,
    .footer {
      height: 100%;
      width: 100%;
      flex-basis: 33%;
    }

    .footer {
      font-size: 2.5em;
    }
  }
</style>
